import TFGSubjectDialog from './TFGSubjectDialog';

export default TFGSubjectDialog;